import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    { paint: 'bushDark', d: 'M0,-1h0.5v0.5h-0.5zM-2,-0.5h4.5v0.5h-4.5zM-2,0h3v0.5h-3z' },
    {
      paint: 'pine',
      d: 'M-0.5,-2.5h0.5v0.5h-0.5zM-2,-2h0.5v0.5h-0.5zM-0.5,-2h1v0.5h-1zM-1.5,-1.5h0.5v1h-0.5zM-0.5,-1.5h0.5v1h-0.5zM1,-1.5h1v1h-1z',
    },
    {
      paint: 'leafLight',
      d: 'M0.5,-2h0.5v0.5h-0.5zM-2.5,-1.5h1v0.5h-1zM0,-1.5h1v0.5h-1zM-2,-1h0.5v0.5h-0.5z',
    },
    {
      paint: 'flower',
      d: 'M-2,-3.5h1v0.5h-1zM-2.5,-3h1.5v0.5h-1.5zM-2.5,-2.5h0.5v0.5h-0.5zM-1.5,-2.5h1v0.5h-1z',
    },
    {
      paint: 'wildflower',
      d: 'M0,-4h0.5v0.5h-0.5zM-1,-3.5h2v0.5h-2zM-0.5,-3h1.5v0.5h-1.5zM0,-2.5h1v0.5h-1z',
    },
    {
      paint: 'butterflyWing',
      d: 'M1.5,-3h1v0.5h-1zM-2,-2.5h0.5v0.5h-0.5zM1,-2.5h1.5v1h-1.5zM-1.5,-2h0.5v0.5h-0.5zM2,-1.5h0.5v0.5h-0.5z',
    },
  ],
  pixels: 63,
};
export const sprites: readonly PixelSprite[] = [variant0, variant0, variant0];
